import React from 'react';

/** @deprecated - prefer `design-system/Dialog` (DialogActions) */
export const ModalFooter: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <footer>
      {children}
      <style jsx>{`
        footer {
          padding: 20px;
          border-top: 1px solid #f1f1f1;
          text-align: center;
        }
      `}</style>
    </footer>
  );
};
